import algoliasearch, { SearchClient } from 'algoliasearch';

let searchClient: SearchClient;

const getSearchClient = (appId?: string, apiKey?: string) => {
  if (!searchClient && appId && apiKey) {
    searchClient = algoliasearch(
      appId,
      apiKey
    );
  }

  return searchClient;
};

export default getSearchClient;
